import React from 'react';

import type {
  EmployeeChangeLogUpdatedFields,
  PersonChangeLogUpdatedFields,
  UpdatedField,
} from '../../typescript-types/employee-change-log';

import { EmployeeHistoryEmployeeGroupDetail } from './employee-history-employee-group-detail';
import { EmployeeHistoryEmployeePersonDetail } from './employee-history-employee-person-detail';
import { EmployeeHistorySupervisorSubordinateDetail } from './employee-history-supervisor-subordinate-detail';

type EmployeeChangeLogDetailsProps = {
  changeHistoryId: number;
  orgsInAccount: Array<Org>;
  employeeGroupsInOrg: EmployeeGroup[];
  employeesInOrg: Employee[];
  employeeChanges?: EmployeeChangeLogUpdatedFields;
  subordinateChanges?: UpdatedField<Array<number>>;
  groupChanges?: UpdatedField<Array<number>>;
  personChanges?: PersonChangeLogUpdatedFields | null;
  supervisorChanges?: UpdatedField<Array<number>>;
  employeeHistoryDetailClassName?: string;
  useKeys?: boolean;
};

export const EmployeeChangeLogDetails = ({
  changeHistoryId,
  employeeChanges,
  personChanges,
  orgsInAccount,
  groupChanges,
  employeeGroupsInOrg,
  supervisorChanges,
  subordinateChanges,
  employeesInOrg,
  employeeHistoryDetailClassName,
  useKeys,
}: EmployeeChangeLogDetailsProps) => (
  <>
    <EmployeeHistoryEmployeePersonDetail
      key={useKeys ? `employee-history-employee-detail-${changeHistoryId}` : undefined}
      className={employeeHistoryDetailClassName}
      changeHistoryId={changeHistoryId}
      employeeChanges={employeeChanges}
      personChanges={personChanges}
      orgsInAccount={orgsInAccount}
    />
    <EmployeeHistoryEmployeeGroupDetail
      key={useKeys ? `employee-history-group-detail-${changeHistoryId}` : undefined}
      changeHistoryId={changeHistoryId}
      groupChanges={groupChanges}
      employeeGroups={employeeGroupsInOrg}
    />
    <EmployeeHistorySupervisorSubordinateDetail
      key={
        useKeys ? `employee-history-supervisor-subordinate-detail-${changeHistoryId}` : undefined
      }
      changeHistoryId={changeHistoryId}
      supervisorChanges={supervisorChanges}
      subordinateChanges={subordinateChanges}
      employees={employeesInOrg}
    />
  </>
);
